import type { ReactNode } from 'react';

export const symbol_filter_arrow_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M805-325H646q-13 0-21.5-8.5T616-355q0-13 8.5-21.5T646-385h159l-56-56q-9-9-9-21t9-21q9-9 21.5-9t21.5 9l107 107q5 5 7 10t2 11q0 6-2 11t-7 10L791-227q-9 8-21 8.5t-21-8.5q-9-9-9-21t9-21l56-56ZM439-448l227-292H212l227 292Zm-71 6L126-752q-3-5-4.5-9t-1.5-9q0-12 8-21t22-9h579q14 0 22 9t8 21q0 5-1.5 9t-4.5 9L511-442v252q0 13-8.5 21.5T481-160h-83q-13 0-21.5-8.5T368-190v-252Z"
		/>
	</svg>
);
